import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import { MaterialIcon } from "components/ui/shared/MaterialIcon";

export const ToolsColumn = ({children, width, ...restProps}) => {

    const ref = useRef(null);
    
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);

    const checkScroll = () => {
        const el = ref.current;

        if (!el) return;

        const canUp = el.scrollTop > 0;

        const canDown =
        el.scrollTop + el.clientHeight < el.scrollHeight - 1;

        setCanScrollUp(canUp);
        setCanScrollDown(canDown);
    };

    useEffect(() => {
        checkScroll();

        const el = ref.current;

        if (!el) return;

        el.addEventListener("scroll", checkScroll);

        // opcjonalnie przy resize
        const resizeObserver = new ResizeObserver(checkScroll);
        resizeObserver.observe(el);

        return () => {
        el.removeEventListener("scroll", checkScroll);
        resizeObserver.disconnect();
        };
    }, []);


    return (
        <StyledToolsColumn {...restProps}>
            <MaterialIcon name="arrow_drop_down" className={canScrollDown ? 'isVisible arrowDownIcon' : 'arrowDownIcon'}/>
            <MaterialIcon name="arrow_drop_up" className={canScrollUp ? 'isVisible arrowUpIcon' : 'arrowUpIcon'}/>
            <div className="content" ref={ref}>
                {children}
            </div>
            
        </StyledToolsColumn>
    )
}

const StyledToolsColumn = styled.div`
    padding: 4px;
    flex: 1;
    overflow: hidden;
    min-height: 0;
    padding: ${({theme}) => theme.spacing.md};
   
    position: relative;
    
    > div.content
    {
        height: 100%;
        overflow: auto;
        display: flex;
        flex-direction: column;
        gap: ${({theme}) => theme.spacing.lg};

        scrollbar-width: none !important;
        -ms-overflow-style: none !important;

        &::-webkit-scrollbar
        {
            display: none !important;
        }
    }

    .arrowDownIcon, .arrowUpIcon
    {
        left: 50%;
        transform: translateX(-50%);
        z-index: 10;
        stroke-width: 3px;
        font-size: ${({theme}) => theme.iconSize.xl};
        
        filter: drop-shadow(0 2px 2px rgba( ${({theme}) => theme.colors.neutralSecondaryForegroundRGB}, 1));
        pointer-events: none;
        transition-duration: 220ms;
        opacity: 0;

        &.isVisible
        {
            opacity: 0.35;
        }
    }

    .arrowDownIcon
    {
        position: absolute;
        bottom: ${({theme}) => theme.spacing.md};

    }

    .arrowUpIcon
    {
        position: absolute;
        top: ${({theme}) => theme.spacing.md};
        
    }
`